import React, { useEffect } from 'react'
import usePersistedFilters from '../../hooks/usePersistedFilters'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import PageHeader from '../../shared/PageHeader'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import useFetchData from '../../hooks/UseFetchData'
import moment from 'moment'
import CustomTable from '../../shared/CustomTable'
import { VisitHistoryColumns } from '../../constants/VisitsConstants'
import CustomPagination from '../../shared/CustomPagination'
import { EyeIcon } from '../../utils/TableActionIcons'
import VisitHistoryFilter from '../../components/his/visits/VisitHistoryFilter'

function VisitHistory () {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const patientDetails = location?.state?.patientDetails
  const { loading, data, executeFetch } = useFetchData()
  const { filters: payload, setFilters: setPayload, appliedFilters, applyFilters, resetFilters, onPageChange } = usePersistedFilters(
    'visit_history',
    {
      page: 1,
      perPage: 10,
      patient_id: patientDetails?.patient_id || '',
      status: 'All',
      start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD')
    }
  )

  const fetchPatientVisits = async (payloadData = appliedFilters) => {
    await executeFetch('POST', '/v3/visit/getPatientVisitById', payloadData)
  }
  const actionTemplate = (rowData, column) => {
    return (
      <div className='flex  gap-1'>
        <EyeIcon
          onClick={() => {
            navigate(
              `/visit-history-detail/${rowData?.patient?.full_name.replace(
                / /g,
                '+'
              )}`,
              {
                state: { visitData: rowData }
              }
            )
          }}
        />
      </div>
    )
  }
  const action = {
    header: t('Action'),
    body: actionTemplate
  }
  const allColumns = [...VisitHistoryColumns(t), action]

  useEffect(() => {
    fetchPatientVisits()
  }, [appliedFilters])

  return (
    <div className='main-page-container !overflow-auto scrollbar'>
      <PageHeader
        title={t('Visit History')}
        iconSize={20}
        Icon={i18n.language == 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
        onIconClick={() => navigate(-1)}
      ></PageHeader>
      <div>
        <VisitHistoryFilter
          setPayloadData={setPayload}
          payloadData={payload}
          applyFilters={applyFilters}
          resetFilters={resetFilters}
          patientDetails={patientDetails}
        />
      </div>
      <div className='w-full h-full mt-4'>
        <CustomTable
          data={data?.data}
          isLoading={loading}
          columns={allColumns}
        />
        <CustomPagination
          currentPage={data?.page}
          rowsPerPage={data?.perPage}
          totalRecords={data?.totalCount}
          totalPages={Math.ceil((data?.totalCount || 0) / (data?.perPage || 1))}
          onPageChange={(newPage, newRowsPerPage) => onPageChange(newPage, newRowsPerPage)}
        />
      </div>
    </div>
  )
}

export default VisitHistory
